export const carouselDetails = [
  {
    title: "EXCLUSIVE NEW SNEAKERS",
    body: "UP TO 30% OFF ALL SNEAKERS",
    color: "rgb(45,135,239)",
    image: "https://res.cloudinary.com/dbxvk3apv/image/upload/v1688165468/1_yy9xlz.jpg"
  },
  {
    title: "EXCLUSIVE NEW HEELS",
    body: "UP TO 30% OFF ALL HEELS",
    color: "rgb(241,79,79)",
    image: "https://res.cloudinary.com/dbxvk3apv/image/upload/v1688165524/e8d65c47-afd0-42d0-9b97-2c19dfcb5067_lstuad.jpg"
  },
  {
    title: "EXCLUSIVE NEW SANDALS",
    body: "UP TO 30% OFF ALL SANDALS",
    color: "rgb(197,59,96)",
    image: "https://res.cloudinary.com/dbxvk3apv/image/upload/v1688165612/61255de3de5f560019e891ee_mu8f7l.jpg"
  },
];
